<script>
    // -- IMPORTS
    
    import AnimatedContainer from "../element/AnimatedContainer.svelte";
    import Media from "../element/Media.svelte";

    // -- VARIABLES

    /** @type {{block?: any, blockIndex?: number}} */
    let { block = $bindable({}) } = $props();
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .image-container
    {
        position: relative;

        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 2.5rem;
        align-items: center;
        align-self: stretch;

        +media( desktop )
        {
            max-width: 77vw;

            gap: 2.5rem;
        }
    }

    .image-block-container
    {    
        height: 18.75rem;
        width: 100%;
        aspect-ratio: 1;

        align-self: stretch;

        +media( desktop )
        {
            height: 39rem;
            aspect-ratio: 3 / 1;
        }
    }

    :global( .image-block )
    {
        aspect-ratio: 1;

        align-self: stretch;
        object-fit: cover;

        +media( desktop )
        {
            height: 39rem;
            width: 44.375rem;
            aspect-ratio: 3 / 4;
        }
    }
</style>

<div>
    {#key block}
        <AnimatedContainer style="width: 100%; display: flex; align-items: center; justify-content: center;">
            <div 
                id={ block.slug || 'id' }
                class="image-container"    
            >
                {#if block.mediaPath || block.mediaPathArray}
                    <div class="image-block-container">
                        <Media
                            mediaPath={ block.mediaPathArray?.length > 0 ? block.mediaPathArray : block.mediaPath }
                            mediaClass="image-block"
                            mediaId={ block.id }
                            mediaPosition={{
                                vertical: block.imageVerticalPosition || 'center',
                                horizontal: block.imageHorizontalPosition || 'center',
                                horizontalArray: block.imageHorizontalPositionArray || [ 'center' ],
                                verticalArray: block.imageVerticalPositionArray || [ 'center' ],
                            }}
                        />
                    </div>
                {/if}
            </div>
        </AnimatedContainer>
    {/key}
</div>